<template>
    <div class="row">
        <div class="card">
            <div class="card-header">
                <div class="grid-2">
                    <h2 class="ml-5">Lista de Boletos</h2>
                    <div class="flex flex-row justify-between">
                        <button class="btn btn-primary" @click="gerarBoletos">
                            Gerar Boletos em Massa
                        </button>
                        <button
                            class="bg-transparent hover:bg-red-600 text-red-600 font-semibold hover:text-white py-2 px-4 border border-red-600 hover:border-transparent rounded"
                            @click="
                                $router.push('/sistema/boletos/incluir-boleto')
                            "
                        >
                            Gerar único boleto
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <vue-good-table
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-per-page-change="onPerPageChange"
                    ref="vue-good-table"
                    :columns="boletos.columns"
                    :rows="boletos.rows"
                    :totalRows="boletos.total"
                    :responsive="true"
                    :pagination-options="{
                        enabled: true,
                        perPage: 10,
                        nextLabel: 'Próximo',
                        prevLabel: 'Anterior',
                        rowsPerPageLabel: 'Resultados por página',
                        ofLabel: 'de',
                        pageLabel: 'página',
                        allLabel: 'Todos'
                    }"
                    styleClass="vgt-table striped"
                >
                    <div slot="emptystate">
                        <div class="text-center">
                            <p>Nenhum dado a ser exibido.</p>
                        </div>
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div v-if="props.column.field === 'download'">
                            <a
                                class="h-6 mb-2"
                                title="Download boleto"
                                :href="props.row.url_boleto"
                                target="_blank"
                            >
                                <svg-icon
                                    icon="download"
                                    class="cursor-pointer text-primary "
                                ></svg-icon>
                            </a>
                        </div>
                        <span>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
export default {
    name: "tabela-boletos",

    components: {
        VueGoodTable
    },

    created() {
        this.getBoletos();
    },

    data() {
        return {
            boletos: {
                columns: [
                    { label: "Sindicato", field: "nome_completo" },
                    { label: "CódBeneficiario", field: "codigo_beneficiario" },
                    { label: "Cód Barras", field: "codigo_barras" },
                    { label: "Nosso Numero", field: "nosso_numero" },
                    { label: "Vencimento", field: "data_vencimento" },
                    { label: "Download Boleto", field: "download" }
                ],
                rows: [],
                total: 0,
                filtros: {
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    page: 1,
                    perPage: 10
                }
            }
        };
    },

    methods: {
        /**
         * Altera a paginação
         * @param params
         */
        onPageChange(params) {
            this.filtrarEventos({ page: params.currentPage });
        },

        /**
         * Filtra pela coluna conforme ascendente/descendente
         * @param params
         */
        onSortChange(params) {
            this.filtrarEventos({
                sort: {
                    type: params[0].type,
                    field: params[0].field
                }
            });
        },

        /**
         * Altera a quantidade de registros por página
         * @param params
         */
        onPerPageChange(params) {
            this.filtrarEventos({ perPage: params.currentPerPage });
        },

        /**
         * Filtra os boletos conforme as mudanças
         * @param newProps
         */
        filtrarEventos(newProps) {
            this.boletos.filtros = Object.assign(
                {},
                this.boletos.filtros,
                newProps
            );
            this.getNoticias();
        },

        async gerarBoletos() {
            let resposta = await this.axios("get-all-configuracoes-boleto");
            let configuracaoBoleto = resposta.data.configuracaoBoleto;
            let vm = this;
            for (var i = 0; i < configuracaoBoleto.length; i++) {
                let formData = new FormData();
                formData.append("data_vencimento", this.gerarDataVencimento());
                formData.append("valor", configuracaoBoleto[i].valor_boleto);
                formData.append(
                    "sindicato_id",
                    configuracaoBoleto[i].sindicato_id
                );
                formData.append("operacao", "INCLUI_BOLETO");
                formData.append(
                    "numero_documento",
                    this.gerarNumeroDocumento()
                );
                setTimeout(async function() {
                    await vm.axios.post("incluir-boleto", formData);
                }, i * 2000);
            }
        },

        getBoletos() {
            this.axios("boletos", {
                params: {
                    page: this.boletos.filtros.page,
                    per_page: this.boletos.filtros.perPage,
                    sortField: this.boletos.filtros.sort.field,
                    sortType: this.boletos.filtros.sort.type
                }
            }).then(response => {
                this.boletos.rows = response.data.boleto.data;
                this.boletos.total = response.data.boleto.total;
            });
        },

        gerarNumeroDocumento() {
            let prefix = "BO";
            let ano = new Date().getFullYear();
            let mes = new Date().getMonth() + 1;
            if (mes == 13) {
                mes -= -1;
            }

            return prefix + mes + ano;
        },

        gerarDataVencimento() {
            let ano = new Date().getFullYear();
            let mes = new Date().getMonth() + 1;
            let dia = "26";
            if (mes == 13) {
                mes -= -1;
            }

            return `${ano}-${mes}-${dia}`;
        }
    }
};
</script>
